module.exports = __webpack_public_path__ + "img/full.312b6574.png";